import TcBack from 'components/UI/Back/TcBack';
import TcPageTitle from 'components/UI/pageTitle/TcPageTitle';
import BranchStandardPackaging from 'components/pages/dashboard/packaging/create/components/BranchStandardPackaging';
import routes from 'global/Constants/routes';
import { packaging } from 'global/Models/packagingModel';
import { FC } from 'react';

interface IPackagingCreatePage {
  handleSelect?: (_packaging: packaging) => void;
  noBack?: boolean;
}

const BranchPackagingCreatePage: FC<IPackagingCreatePage> = ({ handleSelect, noBack }) => {
  return (
    <>
      {!noBack && <TcBack to={routes.packaging.path} />}
      {!handleSelect && <TcPageTitle title='ایجاد بسته' />}
      <BranchStandardPackaging handleSelect={handleSelect} externalLoading={false} />
    </>
  );
};

export default BranchPackagingCreatePage;
